module.exports = __webpack_public_path__ + "static/media/frogFoot.37cbd009.png";